import { NavLink } from "react-router-dom"
import { Home, Lightbulb, PawPrint, User } from "lucide-react"

const tabClass = ({ isActive }: { isActive: boolean }) =>
  [
    "flex flex-col items-center gap-1",
    isActive
      ? "text-[var(--color-text-primary)] font-medium"
      : "text-[var(--color-text-secondary)]",
  ].join(" ")

export function MainTabNav() {
  return (
    <section
      data-testid="main-tab-nav"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-[var(--color-divider)] bg-[var(--color-surface-card)]/95 pb-[env(safe-area-inset-bottom)] pt-2 shadow-[0_-4px_12px_rgba(0,0,0,0.06)] backdrop-blur-sm"
    >
      <nav
        aria-label="Main"
        className="mx-auto grid max-w-lg grid-cols-4 gap-2 px-4 pb-2 text-center text-xs"
      >
        <NavLink to="/dashboard" className={tabClass} end>
          <Home size={18} />
          <span>Home</span>
        </NavLink>
        <NavLink to="/tips" className={tabClass}>
          <Lightbulb size={18} />
          <span>Tips</span>
        </NavLink>
        <NavLink to="/perspectives" className={tabClass}>
          <PawPrint size={18} />
          <span>Dogs</span>
        </NavLink>
        <NavLink to="/profile" className={tabClass}>
          <User size={18} />
          <span>Profile</span>
        </NavLink>
      </nav>
    </section>
  )
}
